import { type ReactElement } from 'react'
import { type UserProfileData } from '@terros/common'
import { Box } from '@mantine/core'
import { MobileAccountTile } from './MobileAccountTile'
import { DesktopAccountMenu } from './DesktopAccountMenu'

type SidebarUserFooterProps = {
  user?: UserProfileData
  isOpen: boolean
  onNavigate?: VoidFunction
}

export const SidebarUserFooter = ({ user, isOpen, onNavigate }: SidebarUserFooterProps): ReactElement => {
  return (
    <>
      <Box visibleFrom='sm'>
        <DesktopAccountMenu isOpen={isOpen} user={user} />
      </Box>
      <Box hiddenFrom='sm'>
        <MobileAccountTile showDetails={isOpen} user={user} onNavigate={onNavigate} />
      </Box>
    </>
  )
}
